const headerSlider = {
    _sliderObject: null,

    init() {
        if(document.querySelectorAll('.js-header-slider').length === 0) {
            return;
        }

        let self = this;
        const scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js';

        window.initPackage(scriptUrl).then(() => {
            self._constructSlider();
        }).catch((error) => {
            console.error(error);
        });
    }, 

    _constructSlider() {
        let self = this;
                
        self._sliderObject = new Swiper('.js-header-slider', {
            direction: 'horizontal',
            loop: true,
            effect: 'slide',
            autoplay: {
                delay: 5000,
            },
            
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

        })
        self._slideCounter();
    },

    _slideCounter() {
        let self = this;    
        let totalCountSlide =  self._sliderObject.slides.length;
        let totalCountNode = document.querySelector('.js-header-slider .js-slider-counter');
        totalCountNode.innerHTML = (self._sliderObject.realIndex + 1) + '/' + totalCountSlide;
        
        self._sliderObject.on('slideChange', function() {
            totalCountNode.innerHTML = (self._sliderObject.realIndex + 1) + '/' + totalCountSlide;
        });
    },

    reInit() {
        let self = this;

        if(self._sliderObject) {
            self._sliderObject.destroy();
            self._sliderObject = null;
        }

        self.init();

    },
}

headerSlider.init();
document.addEventListener('LokiRequestEnd', function () {
    headerSlider.reInit();
});
